import * as S from './styled';

function AccountStatBoxSubtitle ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default AccountStatBoxSubtitle;
